import * as THREE from 'three'
import Experience from '../Experience.js'
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.renderer = this.experience.renderer.instance

        this.scene.colorSpace = THREE.SRGBColorSpace

        this.environment = null

        //this.setEnvironmentMap()
        this.setAmbientLight()
        this.setDirectionalLight()
        //this.setPointLight()

        this.setDebug()
    }

    setAmbientLight() {
        this.ambientLight = new THREE.AmbientLight( '#ffffff', 0.05 )
        this.ambientLight.layers.enable( 0 ); // enabled by default
        this.ambientLight.layers.enable( 1 );
        this.scene.add( this.ambientLight )
    }

    setDirectionalLight() {
        this.directionalLight = new THREE.DirectionalLight( '#ffffff', 1 )
        this.directionalLight.position.set( 0, 5, 5 )
        this.directionalLight.layers.enable( 0 ); // enabled by default
        this.directionalLight.layers.enable( 1 );

        this.scene.add( this.directionalLight )
    }

    setPointLight() {
        this.pointLight = new THREE.PointLight( '#00ffff', 20 )
        this.pointLight.position.set( 0, 5, 0 )
        this.pointLight.layers.enable( 0 ); // enabled by default
        this.pointLight.layers.enable( 1 );

        this.scene.add( this.pointLight )
    }


    setEnvironmentMap() {
        // const environment = new RoomEnvironment( this.renderer );
        // const pmremGenerator = new THREE.PMREMGenerator( this.renderer );
        // // //
        // const env = pmremGenerator.fromScene( environment ).texture;
        // //this.scene.background = env;
        //this.environment = env;
        // //this.scene.backgroundBlurriness = 0.5;
        // //environment.dispose();

        // //set background transparent
        // this.scene.background = null;

    }

    setDebug() {
        if ( this.debug.active ) {

        }
    }
}
